import { Alert, Box, useTheme } from "@mui/material";
import { useParams } from "react-router-dom";

import { NavigationPage } from "@/shared/components";
import { ErrorBoundary } from "@/shared/components/ErrorBoundary";

import { DeviceHeader } from "../DeviceHeader";
import { DeviceTabRoutes } from "../DeviceTabRoutes";
import { DeviceTabs } from "../DeviceTabs";

export function Device() {
  const { deviceId } = useParams();
  const theme = useTheme();

  if (!deviceId) {
    return (
      <NavigationPage title={`Roboto - Device`}>
        <Alert severity="error">Missing device id in path</Alert>
      </NavigationPage>
    );
  }

  return (
    <NavigationPage title={`Roboto - Device - ${deviceId}`}>
      <ErrorBoundary
        fallback={(props) => {
          if (props.error instanceof Error) {
            return <Alert severity="error">{props.error.message}</Alert>;
          }

          return (
            <Alert severity="error">
              Something went wrong. Please contact{" "}
              <a href="mailto:support@roboto.ai">support@roboto.ai</a> if this
              problem persists.
            </Alert>
          );
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: theme.spacing(2),
          }}
        >
          <DeviceHeader deviceId={deviceId} />
          <DeviceTabs deviceId={deviceId} />
          <DeviceTabRoutes deviceId={deviceId} />
        </Box>
      </ErrorBoundary>
    </NavigationPage>
  );
}
